import api, { handleApiError } from './client';

export const athleteAccessService = {
  createToken: async (userId) => {
    try {
      const response = await api.post(`/api/athlete-access/${userId}/token`);
      return {
        success: true,
        data: response.data
      };
    } catch (error) {
      console.error('Create athlete access token error:', error);
      return {
        success: false,
        message: handleApiError(error, 'Errore nella generazione del link')
      };
    }
  },

  sendAccessLink: async (userId, recipientEmailOverride = null) => {
    try {
      const response = await api.post(`/api/athlete-access/${userId}/send-link`, {
        recipientEmailOverride
      });
      return response.data;
    } catch (error) {
      console.error('Send athlete access link error:', error);
      return {
        success: false,
        message: handleApiError(error, "Errore nell'invio del link")
      };
    }
  },

  sendBulkAthleteAccessLinks: async (userIds, customSubject = null, customBody = null) => {
    try {
      const payload = {
        userIds,
        customSubject: customSubject?.trim() || null,
        customBody: customBody?.trim() || null
      };
      const response = await api.post('/api/athlete-access/bulk-send-link', payload);
      return {
        success: response.data.success,
        data: response.data
      };
    } catch (error) {
      console.error('Send bulk athlete access links error:', error);
      return {
        success: false,
        message: handleApiError(error, "Errore nell'invio dei link di accesso")
      };
    }
  },

  revokeAccess: async (userId) => {
    try {
      const response = await api.post(`/api/athlete-access/${userId}/revoke`);
      return response.data;
    } catch (error) {
      console.error('Revoke athlete access error:', error);
      return {
        success: false,
        message: handleApiError(error, "Errore nella revoca dell'accesso")
      };
    }
  },

  getAccessInfo: async (userId) => {
    try {
      const response = await api.get(`/api/athlete-access/${userId}`);
      return {
        success: true,
        data: response.data
      };
    } catch (error) {
      console.error('Get athlete access info error:', error);
      return {
        success: false,
        message: handleApiError(error, 'Errore nel caricamento delle info di accesso')
      };
    }
  },

  getAuditHistory: async (entityType, entityId) => {
    try {
      const response = await api.get('/api/audit/entity', {
        params: { entityType, entityId }
      });
      return {
        success: true,
        data: response.data
      };
    } catch (error) {
      console.error('Get audit history error:', error);
      return {
        success: false,
        message: handleApiError(error, "Errore nel caricamento dell'audit log")
      };
    }
  },

  updateUserLoginEmail: async (userId, newLoginEmail) => {
    try {
      const response = await api.put(`/api/athlete-access/${userId}/login-email`, {
        newLoginEmail
      });
      return response.data;
    } catch (error) {
      console.error('Update user login email error:', error);
      return {
        success: false,
        message: handleApiError(error, "Errore durante l'aggiornamento dell'email di login")
      };
    }
  }
};

export default athleteAccessService;
